import { EVENT_FACTS } from "@/data/content";
import { Reveal, Overline } from "./Reveal";
import { MapPin } from "lucide-react";

export default function Invitation() {
    return (
        <section id="invitation" data-testid="invitation-section" className="relative bg-night-deep px-6 sm:px-12 lg:px-20 py-28 sm:py-36">
            {/* Formal invitation card */}
            <Reveal>
                <div data-testid="invitation-card" className="relative max-w-3xl mx-auto text-center px-6 sm:px-16 py-16 sm:py-20">
                    <div className="absolute inset-0 border border-gold/30 pointer-events-none" />
                    <div className="absolute inset-2 border border-gold/15 pointer-events-none" />
                    <p className="text-[11px] sm:text-xs tracking-[0.4em] uppercase text-gold">
                        Monsieur et Madame Anton Cox
                    </p>
                    <p className="mt-5 text-[11px] sm:text-xs tracking-[0.4em] uppercase text-gold">
                        vous prient d'assister à la soirée
                    </p>
                    <p className="mt-8 font-display italic text-gold gold-glow text-3xl sm:text-5xl leading-tight">
                        Once Upon a Time<br />in Hollywood
                    </p>
                    <p className="mt-8 text-[11px] sm:text-xs tracking-[0.4em] uppercase text-gold">
                        qu'ils donnent pour
                    </p>
                    <p className="mt-5 font-display text-4xl sm:text-6xl tracking-tight text-gold">
                        leur fille <em>Lavinia</em>
                    </p>
                    <div className="mt-10 flex items-center justify-center gap-5">
                        <span className="h-px w-14 bg-gold/50" />
                        <span className="text-gold text-sm">✦</span>
                        <span className="h-px w-14 bg-gold/50" />
                    </div>
                    <p className="mt-10 text-sm sm:text-base tracking-[0.35em] uppercase text-gold">
                        Le 03 octobre 2026 à 20h
                    </p>
                </div>
            </Reveal>

            {/* Practical information */}
            <Reveal className="mt-28 sm:mt-36">
                <div className="max-w-3xl" data-testid="practical-info">
                    <Overline>Informations Pratiques</Overline>
                    <div className="mt-8 divide-y divide-white/10 border-t border-b border-white/10">
                        {EVENT_FACTS.map((fact, i) => (
                            <div key={fact.label} data-testid={`event-fact-${i}`} className="grid grid-cols-[110px_1fr] gap-6 py-4 items-baseline">
                                <span className="text-[10px] tracking-[0.3em] uppercase text-gold/80">{fact.label}</span>
                                <span className="text-base sm:text-lg font-light text-white/80">{fact.value}</span>
                            </div>
                        ))}
                    </div>
                    <a
                        data-testid="invitation-map-link"
                        href="https://maps.google.com/?q=Le+Piesmont,+All%C3%A9e+des+Grands+Clos+8,+1380+Lasne"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-8 inline-flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-gold link-underline"
                    >
                        <MapPin size={14} strokeWidth={1.5} /> Ouvrir dans Google Maps
                    </a>
                </div>
            </Reveal>
        </section>
    );
}
